import {
  checkResponse,
  getToken,
  post
} from "./http";
import {
  debug
} from "util";

const URL = process.env.VUE_APP_API + "TokenOsapm/GetTokenAfiliado";
const URLPRESTADOR = process.env.VUE_APP_API + "TokenOsapm/GetTokenPrestador";

const URLOSAPM_AFILIADO =
  process.env.VUE_APP_API_EXTERNAL + "/api/Account/ForgotPasswordAfiliado";
const URLOSAPM_PRESTADOR =
  process.env.VUE_APP_API_EXTERNAL + "/api/Account/ForgotPasswordPrestador";

const ERROR_TRYING_TO_CONTACT_SERVER = 'Ha ocurrido un error al intentar comunicarse con el servidor.'

/*
    API
*/
export async function login(tipoDocumento, documentoNumero, password, success, error) {

  let form = {
    tipoDocumentoId: tipoDocumento,
    password: password,
    documentoNumero: documentoNumero
  };

  try {
    var result = await getToken(URL, form).then(checkResponse);
  } catch {
    error(ERROR_TRYING_TO_CONTACT_SERVER);
  }

  if (result.statusText === "OK") {
    var errorMessage = result.data.error_description;
    if (errorMessage) {
      if (errorMessage === "usuarioPasswordIncorrecto") {
        error("El usuario o contraseña son incorrectos.");
        return;
      }
      //Por cualquier otro error
      error(errorMessage);
      return;
    }
    debugger;
    let token = result.data.access_token;
    //localStorage.setItem("TOKEN_AFILIADO", token);
    window.location =
      process.env.VUE_APP_BACKEND + "#/user/afiliadoTokenCallback/" + token;
  } else {
    error(ERROR_TRYING_TO_CONTACT_SERVER);
  }
}

export async function loginPrestador(userName, password, success, error) {
  let form = {
    userName: userName,
    password: password,
    role: "prestador"
  };

  try {
    var result = await getToken(URLPRESTADOR, form).then(checkResponse);
  } catch {
    error("Ha ocurrido un error al intentar comunicarse con el servidor.");
  }

  if (result.statusText === "OK") {
    var errorMessage = result.data.error_description;
    if (errorMessage) {
      if (errorMessage === "usuarioPasswordIncorrecto") {
        error("El usuario o contraseña son incorrectos.");
        return;
      }
      //Por cualquier otro error
      error(errorMessage);
      return;
    }

    let token = result.data.access_token;
    //localStorage.setItem("TOKEN_AFILIADO", token);
    window.location =
      process.env.VUE_APP_BACKEND + "#/user/PrestadorTokenCallback/" + token;
  } else {
    errorMessage = "Error getting token"
    error(errorMessage);
  }
}

/*
  Reset Afiliado
*/
export async function reset(axios, tipoDocumento, documentoNumero, success, error) {
  let form = {
    CallBack: process.env.VUE_APP_FRONTEND + "#/password/change",
    TipoDocumentoId: tipoDocumento,
    DocumentoNumero: documentoNumero
  };

  try {
    var result = await axios
      .post("Account/ForgotPasswordAfiliado", form)
      .then(checkResponse);
  //  if (result.data.Email) {
      success("Si la cuenta existe se enviará un mail para restablecer la contraseña");
     // success("Se ha enviado un correo electrónico a la dirección: " + result.data.Email)
   // }
  } catch (errorResponse) {
    error(ERROR_TRYING_TO_CONTACT_SERVER)
    console.log("resultado: " + result);
  }
}

export async function changePassword(
  axios,
  Code,
  UserId,
  Password,
  ConfirmPassword,
  success,
  error
) {
  let form = {
    Code: Code,
    UserId: UserId,
    Password: Password,
    ConfirmPassword: ConfirmPassword
  };

  if (Code.includes("%")) {
    form.Code = decodeURIComponent(Code);
  }
  let errorExists = false;

  var result = await axios
    .post("Account/ResetPassword", form)
    .then(checkResponse)
    .catch(function (errorResponse) {
      errorExists = true;
      if (errorResponse.response.data) {
        var {
          ModelState
        } = errorResponse.response.data;

        if (ModelState[""]) {
          error(ModelState[""]);
          return;
        }

        if (ModelState["model.Password"]) {
          error(ModelState["model.Password"]);
          return;
        }

        return
      }
      error(ERROR_TRYING_TO_CONTACT_SERVER)
      return;
    });
  if (!errorExists) success("Se ha cambiando la contraseña correctamente.")
}

/*
  Reset Prestador
*/
export async function resetPrestador(axios, username, success, error) {
  let form = {
    CallBack: process.env.VUE_APP_FRONTEND + "#/password/change",
    Username: username,
  };

  try {
    var result = await axios
      .post("Account/ForgotPasswordPrestador", form)
      .then(checkResponse);
   // if (result.data.Email) {
      success("Si la cuenta existe se enviará un mail para restablecer la contraseña")
      //success("Se ha enviado un correo electrónico a la dirección: " + result.data.Email)
  //  }
  } catch (errorResponse) {
    debugger
    error(ERROR_TRYING_TO_CONTACT_SERVER)
  }
}